exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-group-container[data-v-eb995a38] {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}", ""]);

// exports
